
import XHeader from 'vux/src/components/x-header/index.vue'

import Result from '@/components/result'
export default {
name: 'info',
props: [],
components: {
XHeader,
Result
},
data () {
return {
resultMsg: {
state: '0',
successMsg: '预约成功，请按时体检',
errorMsg: '预约失败，稍后请重新预约',
successBtn: [
{
name: '取消',
type: 'warn',
callback: () => {
this.resultMsg.confirmShow.state = true
this.resultMsg.confirmShow.content = '确定取消本次预约吗？'
this.resultMsg.confirmShow.type = 'cancel'
}
},
{
name: '编辑',
type: 'brand',
callback: () => {
this.resultMsg.confirmShow.state = true
this.resultMsg.confirmShow.content = '确定编辑本次预约信息吗？'
this.resultMsg.confirmShow.type = 'edit'
}
}
],
errorBtn: '重新预约',
infoTitle: '预约信息',
infoList: [{
label: '地点',
value: '兴庆校区校医院'
}, {
label: '姓名',
value: '李泽言'
}, {
label: '预约号',
value: '19035'
}, {
label: '预约体检时间',
value: '2019-09-02 10:00-12:00'
}, {
label: '预约提交时间',
value: '2019-08-30 14:30:15'
}],
confirmShow: {
state: false,
content: '',
type: ''
}
}
}
},
computed: {
title () {
return this.$route.meta.title
}
},
created () {},
mounted () {},
updated () {},
destroyed () {},
watch: {},
methods: {
back () {
setTimeout(() => {
this.$router.back(-1)
}, 300)
},
onConfirm (msg) {
setTimeout(() => {
this.back()

}, 300)
},
onCancel () {
this.confirmShow = false
}
}
}



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/views/items/medical/medicalResult.vue